import IMatrixComponent from '@components/FormFlow/Interfaces/FormflowComponents/IMatrixComponent';
import IResult from '@components/FormFlow/Interfaces/FormflowComponents/Util/IResult';
import I18n from '@src/i18n';
import { Theme } from '@src/styled-components';
import { Button, Col, Icon, Input, InputNumber, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { InstructionTaskComponent } from '../TextInstructionComponent';

//FIXME: esses valores são fixos?
const columns = [{
  title: '',
  dataIndex: 'name',

}, {
  title: 'Chance Baixa (1)',
  dataIndex: 'low',
}, {
  title: 'Chance Média (2)',
  dataIndex: 'medium',
}, {
  title: 'Chance Alta (3)',
  dataIndex: 'hard',
}];

const data = [{
  key: '1',
  name: 'Ferimento Leve  (10)',
  low: '10',
  medium: '30',
  hard: '40',
}, {
  key: '2',
  name: 'Ferimento Grave  (20)',
  low: '20',
  medium: '60',
  hard: '80',
}];

interface IMatrixTaskComponentStateType {
  columnMatrix: any[];
  inputValueColumnRepresent: string;
  inputValueLineRepresent: string;
  instructionTitle: string;
  lineMatrix: any[];
  results: IResult[];
  description?: string;
  required: boolean
};

export default class MatrixTaskComponent extends React.Component<IMatrixComponent, IMatrixTaskComponentStateType> {

  constructor(props: IMatrixComponent) {
    super(props);
    this.state = {
      instructionTitle: '',
      inputValueLineRepresent: '',
      inputValueColumnRepresent: '',
      lineMatrix: [{ nameLine: '', valueLine: undefined }],
      columnMatrix: [{ nameColumn: '', valueColumn: undefined }],
      results: [{ min: undefined, max: undefined, label: '' }],
      required: false
    };
  }

  componentDidMount() {
    this.setState({ results: this.props.results })
  }

  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }

  handleInputValueLinesRepresentChange = async (evt: any) => {
    this.setState({ inputValueLineRepresent: evt.target.value });
  }

  handleInputValueColumnsRepresentChange = async (evt: any) => {
    this.setState({ inputValueColumnRepresent: evt.target.value });
  }

  handleInputNameLineChange = (idx: any) => (evt: any) => {
    const newLineMatrix = this.state.lineMatrix.map((lineMatrixItems, sidx) => {
      if (idx !== sidx) return lineMatrixItems;
      return { ...lineMatrixItems, nameLine: evt.target.value };
    });
    this.setState({ lineMatrix: newLineMatrix });
    console.log('valor do input', this.state.lineMatrix)
  }

  handleInputValueLineChange = (idx: any) => (evt: any) => {
    const newLineMatrix = this.state.lineMatrix.map((lineMatrixItems, sidx) => {
      if (idx !== sidx) return lineMatrixItems;
      return { ...lineMatrixItems, valueLine: evt.target.value };
    });
    this.setState({ lineMatrix: newLineMatrix });
  }

  handleAddNewLineMatrix = async () => {
    this.setState({
      lineMatrix: this.state.lineMatrix.concat([{ nameLine: '', valueLine: undefined }]),
    });
  }

  handleRemoveLineMtrix = (index: number) => async () => {
    this.setState({
      lineMatrix: this.state.lineMatrix.filter((section: any, sindex: number) => index !== sindex),
    });
  }

  handleInputNameColumnChange = (idx: any) => (evt: any) => {
    const newColumnMatrix = this.state.columnMatrix.map((columMatrixItems, sidx) => {
      if (idx !== sidx) return columMatrixItems;
      return { ...columMatrixItems, nameColumn: evt.target.value };
    });
    this.setState({ columnMatrix: newColumnMatrix });
  }

  handleInputValueColumnChange = (idx: any) => (evt: any) => {
    const newColumnMatrix = this.state.columnMatrix.map((columMatrixItems, sidx) => {
      if (idx !== sidx) return columMatrixItems;
      return { ...columMatrixItems, valueColumn: evt.target.value };
    });
    this.setState({ columnMatrix: newColumnMatrix });
  }

  handleAddNewColumnMatrix = async () => {
    this.setState({
      columnMatrix: this.state.columnMatrix.concat([{ nameColumn: '', valueColumn: undefined }]),
    });
  }

  handleRemoveColumnMtrix = (index: number) => async () => {
    this.setState({
      columnMatrix: this.state.columnMatrix.filter((section: any, sindex: number) => index !== sindex),
    });
  }

  handleResultLabelChange = (idx: any) => (evt: any) => {
    if (this.state.results !== undefined) {
      const newResult = this.state.results.map((resultItems, sidx) => {
        if (idx !== sidx) return resultItems;
        return { ...resultItems, label: evt.target.value };
      });


      this.setState({ results: newResult });
    }
  }

  handleResultMinChange = (idx: any) => (evt: any) => {
    if (this.state.results !== undefined) {
      const newResult = this.state.results.map((resultItems, sidx) => {
        if (idx !== sidx) return resultItems;
        return { ...resultItems, min: evt.target.value };
      });


      this.setState({ results: newResult });
    }
  }


  handleAddResult = async () => {
    if (this.state.results !== undefined) {
      this.setState({
        results: this.state.results.concat([{ min: undefined, max: undefined, label: '' }]),
      });

    }
  }

  handleRemoveResult = (idx: any) => async () => {
    if (this.state.results !== undefined) {
      this.setState({
        results: this.state.results.filter((s, sidx) => idx !== sidx),
      });
    }
  }
  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }

  handleRequiredChange = async (evt: any) => {
    this.setState({ required: evt.target.checked });
  }

  render() {
    const {
      inputValueLineRepresent,
      inputValueColumnRepresent,
    } = this.state;

    return (
      <Wrapper>
        <div style={{ width: "60%" }} >
          <InstructionTaskComponent
            conditionsTaskComponents={true}
            inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
            tableShowing={true}
            columnsTable={columns}
            onChangeDescription={() => this.handleDescriptionChange}
            onChangeRequiredCheckbox={() => this.handleRequiredChange}
            dataTable={data}
            visibleDescription={true}
            inputTitleValue={this.props.title}
            requiredCheckedValue={this.props.required}
            onInputInstructionChange={() => this.handleIntructionTitleChange}
            titleComponent={I18n.l("formflow.components.matrixComponent.titleMatrixComponent")}
            descriptionComponent={I18n.l("formflow.components.matrixComponent.descriptionMatrixComponent")}
            exampleDescriptionComponent={I18n.l("formflow.components.matrixComponent.exampleDescriptionMatrixComponent")}
          />
        </div>
        <div>
          <DividerBorder />
          <Row>
            <Col sm={12} md={12} xl={12}>
              <div className="input-lines-represents">
                <p>{I18n.l("formflow.components.matrixComponent.lineRepresentMatrixComponent")}</p>
                <Input
                  style={{ fontWeight: 'bold' }}
                  defaultValue={this.props.labelX}
                  className={inputValueLineRepresent.length === 70 ? "apply-shake" : ''}
                  maxLength={70}
                  onChange={this.handleInputValueLinesRepresentChange}
                />
                <p style={{ float: 'right' }} className={inputValueLineRepresent.length < 70 ? "count-input" : "count-input-red"} >
                  {inputValueLineRepresent.length !== 0 ? inputValueLineRepresent.length + ' / 70' : '0 / 70'}
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} xl={12}>
              <div className="input-columns-represents">
                <p>{I18n.l("formflow.components.matrixComponent.columnRepresentMatrixComponent")}</p>
                <Input
                  style={{ fontWeight: 'bold' }}
                  defaultValue={this.props.labelY}
                  className={inputValueColumnRepresent.length === 70 ? "apply-shake" : ''}
                  maxLength={70}
                  onChange={this.handleInputValueColumnsRepresentChange}
                />
                <p style={{ float: 'right' }} className={inputValueColumnRepresent.length < 70 ? "count-input" : "count-input-red"} >
                  {inputValueColumnRepresent.length !== 0 ? inputValueColumnRepresent.length + ' / 70' : '0 / 70'}
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} xl={12}>
              <Row style={{ width: '100%' }} >
                {this.props.optionsX.map((list: any, idx: number) => (
                  <div key={idx}>
                    <Col sm={12} md={12} xl={12}>
                      <div className="input-item-style">
                        <p>{I18n.l("formflow.components.matrixComponent.nameLine")}</p>
                        <Input
                          defaultValue={list.value}
                          className={list.value.length === 70 ? "apply-shake" : ''}
                          maxLength={70}
                          value={list.value}
                          onChange={this.handleInputNameLineChange(idx)}
                        />
                        <p style={{ float: 'right' }} className={list.value.length < 70 ? "count-input" : "count-input-red"} >
                          {list.value.length !== 0 ? list.value.length + ' / 70' : '0 / 70'}
                        </p>
                      </div>
                    </Col>
                    <Col sm={12} md={12} xl={12}>
                      <div className="input-score-style">
                        <p>{I18n.l("formflow.components.matrixComponent.valueMatrix")}</p>
                        <InputNumber
                          style={{ width: '50%' }}
                          defaultValue={list.weight}
                          value={list.weight}
                          onChange={this.handleInputValueLineChange(idx)}
                        />
                        <Icon
                          style={{ color: 'red', marginLeft: '10px', cursor: "pointer" }}
                          type="close"
                          // disabled={x.lenght === 1}
                          onClick={this.handleRemoveLineMtrix(idx)}
                        />
                      </div>
                    </Col>
                  </div>
                ))}
              </Row>
              <ButtonStyle>
                <Button onClick={this.handleAddNewLineMatrix} className="goepik-btn-border-main">
                  <Icon type="plus" /> {I18n.l("formflow.buttons.addLineMatrix").toUpperCase()}
                </Button>
              </ButtonStyle>
            </Col>
            {/* Coluna da Matriz */}
            <Col sm={12} md={12} xl={12}>
              <Row style={{ width: '100%' }} >
                {this.props.optionsY.map((list: any, idx: number) => (
                  <div key={idx}>
                    <Col sm={12} md={12} xl={12}>
                      <div className="input-item-style">
                        <p>{I18n.l("formflow.components.matrixComponent.nameColumn")}</p>
                        <Input
                          defaultValue={list.value}
                          className={list.value.length === 70 ? "apply-shake" : ''}
                          maxLength={70}
                          value={list.value}
                          onChange={this.handleInputNameColumnChange(idx)}
                        />
                        <p style={{ float: 'right' }} className={list.value.length < 70 ? "count-input" : "count-input-red"} >
                          {list.value.length !== 0 ? list.value.length + ' / 70' : '0 / 70'}
                        </p>
                      </div>
                    </Col>
                    <Col sm={12} md={12} xl={12}>
                      <div className="input-score-style">
                        <p>{I18n.l("formflow.components.matrixComponent.valueMatrix")} </p>
                        <InputNumber
                          style={{ width: '50%' }}
                          defaultValue={list.weight}
                          value={list.weight}
                          onChange={this.handleInputValueColumnChange(idx)}
                        />
                        <Icon
                          style={{ color: 'red', marginLeft: '10px', cursor: "pointer" }}
                          type="close"
                          onClick={this.handleRemoveColumnMtrix(idx)}
                        />
                      </div>
                    </Col>
                  </div>
                ))}
              </Row>
              <ButtonStyle>
                <Button onClick={this.handleAddNewColumnMatrix} className="goepik-btn-border-main">
                  <Icon type="plus" /> {I18n.l("formflow.buttons.addColumnMatrix").toUpperCase()}
                </Button>
              </ButtonStyle>
            </Col>
          </Row>
          <DividerBorder />
          <div className="input-title-result-style" >
            <p>{I18n.l("formflow.components.matrixComponent.titleResultmatrix")}</p>
          </div>
          <form >
            {

              (this.props.results.map((resulitems, idx) => (
                <div className="shareholder goepik-component-padding" >
                  <div className="input-item-style">
                    <Row>
                      {I18n.l('form.taskflowschedule.labels.resulmultimatriz')}

                      <Input
                        defaultValue={String(resulitems.min)}
                        style={{ width: '10%', marginLeft: '10px' }}
                        onChange={this.handleResultMinChange(idx)}
                      />
                      <div>
                        <br />
                        <Row>
                          <div>
                            {I18n.l('form.taskflowschedule.labels.statstaskmatriz')}
                            <Input
                              defaultValue={resulitems.label}
                              className={resulitems.label.length === 70 ? "apply-shake" : ''}
                              style={{ width: '50%' }}
                              onChange={this.handleResultLabelChange(idx)}
                            />

                            {
                              idx >= 0 ? (
                                <Icon
                                  style={{ color: 'red', marginLeft: '10px' }}
                                  className="dynamic-delete-button"
                                  type="close"
                                  onClick={this.handleRemoveResult(idx)}
                                />
                              ) : null
                            }
                          </div>
                        </Row>
                      </div>
                    </Row>
                  </div>
                </div>

              )))}
            <ButtonStyle>
              <Button onClick={this.handleAddResult} className="goepik-btn-border-main">
                <Icon type="plus" /> {I18n.l("formflow.buttons.addStatusMatrix").toUpperCase()}
              </Button>
            </ButtonStyle>

          </form>

        </div>

      </Wrapper>
    );
  }
}
const Wrapper = styled.div`
    width:100%;
    margin-bottom: 10rem;
    .input-lines-represents{
        font-weight: bold;
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }
    .input-columns-represents{
        font-weight: bold;
        width:50%;
        margin-top: 1rem;
        margin-left: 3rem;
        margin-right: 3rem;
    }

    .input-item-style{
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 80%;
    }
    .input-title-result-style{
        font-weight: bold;
        margin-top: 3rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 80%;
    }
    .input-result-style{
        margin-top: 2rem;
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 50%;
    }
    .input-score-style{
        margin-bottom: 2rem;
        margin-left: 3rem;
        margin-right: 3rem;
        width 100%;
    }
    .delete-style{
        margin-top: 2rem;
    }
    .count-input{
        margin-top:2px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
    }
    .count-input-red{
        margin-top:2px;
        color: ${Theme.secondary.red};
        font-weight: bold;
    }
    @keyframes shake {
        10%, 90% {
          transform: translate3d(-1px, 0, 0);
        }
      
        20%, 80% {
          transform: translate3d(2px, 0, 0);
        }
      
        30%, 50%, 70% {
          transform: translate3d(-4px, 0, 0);
        }
      
        40%, 60% {
          transform: translate3d(4px, 0, 0);
        }
      }
      .apply-shake {
          animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
      }

`

const DividerBorder = styled.div`
    margin-top: 2rem;
    margin-left: 3rem;
    margin-right: 3rem;   
    border-bottom: 1px solid ${Theme.secondary.midGrey};
`;

const ButtonStyle = styled.div`
    margin-left: 3rem;
    margin-right: 3rem;  
`;
